import { render, staticRenderFns } from "./real-name-buyer.vue?vue&type=template&id=448e0736&scoped=true&"
import script from "./real-name-buyer.vue?vue&type=script&lang=js&"
export * from "./real-name-buyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e0736",
  null
  
)

export default component.exports